import { render, staticRenderFns } from "./RoskildeButton.vue?vue&type=template&id=436c3f0c&scoped=true&"
import script from "./RoskildeButton.vue?vue&type=script&lang=js&"
export * from "./RoskildeButton.vue?vue&type=script&lang=js&"
import style0 from "./RoskildeButton.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./RoskildeButton.vue?vue&type=style&index=1&id=436c3f0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436c3f0c",
  null
  
)

export default component.exports